import { Descriptions } from 'antd';
import { FormattedMessage } from 'react-intl';

const InfoBlock = ({ keys }) => (
  <Descriptions title={<FormattedMessage id="title" />} column={1}>
    {keys.map((key) => (
      <Descriptions.Item label={<FormattedMessage id={`requisites.${key}.title`} />}>
        {<FormattedMessage id={`requisites.${key}.value`} />}
      </Descriptions.Item>
    ))}
  </Descriptions>
);

export default InfoBlock;
